import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { Tooltip } from '@hivebrite/design-system/Tooltip';

import {
  getLowerCaseMentorLabel,
  getLowerCaseMenteeLabel,
} from 'hb-react/frontoffice/apps/Mentoring/utils';

interface AvailableProps {
  disabledAccess?: boolean;
  hasReachedMenteesLimit?: boolean;
  menteeLabel: string;
  mentorLabel: string;
  onClickSubmitApplication?: () => void;
}

const Available = ({
  hasReachedMenteesLimit,
  mentorLabel,
  menteeLabel,
  onClickSubmitApplication,
  disabledAccess,
}: AvailableProps) => {
  const tooltip = hasReachedMenteesLimit
    ? s__(
        'Mentoring|This %{mentorLabel} has reached their limit of %{menteeLabel}',
      ).i__({
        mentorLabel: getLowerCaseMentorLabel(mentorLabel),
        menteeLabel: getLowerCaseMenteeLabel(menteeLabel),
      })
    : null;

  return (
    <Tooltip childrenElement={tooltip}>
      <Box flexDirection="column" alignItems="flex-start" mt={4}>
        <Button
          isFullWidth
          onClick={onClickSubmitApplication}
          isDisabled={hasReachedMenteesLimit || disabledAccess}
        >
          {s__('Mentoring|Submit an application')}
        </Button>
      </Box>
    </Tooltip>
  );
};

export default Available;
